module.exports = __webpack_public_path__ + "static/media/partager-message.0b195641.png";